// Relative imports
import { axiosInstance } from "./common.jsx";

export const getProfile = async () => {
  const endpoint = "profile/";
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const getProfileDetailed = async () => {
  const endpoint = "profile/detailed/";
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const createProfile = async (data) => {
  const endpoint = "profile/";
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const updateProfile = async (data) => {
  // {
  //   "avatar": "string",
  //   "username": "string",
  //   "first_name": "string",
  //   "last_name": "string",
  //   "bio": "string",
  //   "phonenumber": "string"
  // }
  const endpoint = "profile/";
  return axiosInstance
    .patch(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// DEPRECATED
export const getProfileById = async (user_id) => {
  const endpoint = `profile/${user_id}/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const validateUsername = async (username) => {
  const endpoint = `auth/validate-username/`;
  return axiosInstance
    .post(endpoint, { username: username })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
